'use client';

import howToImg from '@/assets/images/lottery/how-to.jpg';
import howToWorldShoppingImg from '@/assets/images/lottery/how-to-world-shopping.jpg';
import ImageView from '@/components/ui/ImageView/ImageView';
import { useTranslation } from 'react-i18next';
import { getLocalizedText } from '@/lib/l18n/function';

function LotteryDetailHowToImage({
  isFamimaKuji,
  howToFamimaImgSrc,
  dataTestId,
} : {
  isFamimaKuji: boolean;
  howToFamimaImgSrc: string;
  dataTestId: string;
}) {
  const { i18n } = useTranslation();
  const howToImgSrc: string = getLocalizedText(i18n.resolvedLanguage, { ja: howToImg.src, en: howToWorldShoppingImg.src ?? howToImg.src });
  return (
    <ImageView src={isFamimaKuji ? howToFamimaImgSrc : howToImgSrc} isFreeSize dataTestId={dataTestId} />
  );
}

export default LotteryDetailHowToImage;
